export default __webpack_public_path__ + "static/settings-8a5b239ace9d7e89e051c122667bda7f.png";